export default __webpack_public_path__ + "static/pyme-c52cc0964c2c9d9e2bebb67f0c5603ca.png";